import React from 'react';
import { Select } from 'antd';
import { useTranslation } from "react-i18next";

interface IProps {
    value: number | null;
    onChange: (value: number | null) => void;
}

const LeasingSelectYear = (props: IProps) => {
    const { t } = useTranslation();
    const { value, onChange } = props;

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - i);

    return (
        <Select
            placeholder={t("msg.selectPlaceholder")}
            value={value}
            onChange={onChange}
            style={{ width: 120 }}
            options={[
                { value: null, label: "Всего" },
                ...years.map((year) => ({
                    value: year,
                    label: year.toString(),
                }))
            ]}
            showSearch
            allowClear
        />
    );
};

export default LeasingSelectYear;
